const nasobilkaSedmi = () => {
	return [
		{
			id: 1,
			priklad: '5 x 7',
			moznosti: [
				{
					id: 1,
					moznost: '35',
				},
				{
					id: 2,
					moznost: '28',
				},
				{
					id: 3,
					moznost: '42',
				},
				{
					id: 4,
					moznost: '21',
				},
			],
			vysledek: '35',
		},
		{
			id: 2,
			priklad: '7 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '30',
				},
				{
					id: 2,
					moznost: '36',
				},
				{
					id: 3,
					moznost: '48',
				},
				{
					id: 4,
					moznost: '42',
				},
			],
			vysledek: '42',
		},
		{
			id: 3,
			priklad: '7 x 7',
			moznosti: [
				{
					id: 1,
					moznost: '63',
				},
				{
					id: 2,
					moznost: '56',
				},
				{
					id: 3,
					moznost: '42',
				},
				{
					id: 4,
					moznost: '49',
				},
			],
			vysledek: '49',
		},
		{
			id: 4,
			priklad: '9 x 7',
			moznosti: [
				{
					id: 1,
					moznost: '49',
				},
				{
					id: 2,
					moznost: '56',
				},
				{
					id: 3,
					moznost: '63',
				},
				{
					id: 4,
					moznost: '70',
				},
			],
			vysledek: '63',
		},
		{
			id: 5,
			priklad: '7 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '35',
				},
				{
					id: 2,
					moznost: '28',
				},
				{
					id: 3,
					moznost: '21',
				},
				{
					id: 4,
					moznost: '42',
				},
			],
			vysledek: '35',
		},
		{
			id: 6,
			priklad: '7 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '42',
				},
				{
					id: 2,
					moznost: '63',
				},
				{
					id: 3,
					moznost: '56',
				},
				{
					id: 4,
					moznost: '49',
				},
			],
			vysledek: '56',
		},
		{
			id: 7,
			priklad: '10 x 7',
			moznosti: [
				{
					id: 1,
					moznost: '70',
				},
				{
					id: 2,
					moznost: '63',
				},
				{
					id: 3,
					moznost: '56',
				},
				{
					id: 4,
					moznost: '49',
				},
			],
			vysledek: '70',
		},
		{
			id: 8,
			priklad: '4 x 7',
			moznosti: [
				{
					id: 1,
					moznost: '28',
				},
				{
					id: 2,
					moznost: '21',
				},
				{
					id: 3,
					moznost: '35',
				},
				{
					id: 4,
					moznost: '42',
				},
			],
			vysledek: '28',
		},
		{
			id: 9,
			priklad: '7 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '28',
				},
				{
					id: 2,
					moznost: '21',
				},
				{
					id: 3,
					moznost: '14',
				},
				{
					id: 4,
					moznost: '7',
				},
			],
			vysledek: '14',
		},
		{
			id: 10,
			priklad: '1 x 7',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '21',
				},
				{
					id: 3,
					moznost: '14',
				},
				{
					id: 4,
					moznost: '28',
				},
			],
			vysledek: '7',
		},
		{
			id: 11,
			priklad: '14 : 7',
			moznosti: [
				{
					id: 1,
					moznost: '3',
				},
				{
					id: 2,
					moznost: '2',
				},
				{
					id: 3,
					moznost: '1',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '2',
		},
		{
			id: 12,
			priklad: '35 : 7',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '4',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '5',
		},
		{
			id: 13,
			priklad: '7 : 7',
			moznosti: [
				{
					id: 1,
					moznost: '4',
				},
				{
					id: 2,
					moznost: '2',
				},
				{
					id: 3,
					moznost: '1',
				},
				{
					id: 4,
					moznost: '3',
				},
			],
			vysledek: '1',
		},
		{
			id: 14,
			priklad: '42 : 7',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '8',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '6',
		},
		{
			id: 15,
			priklad: '63 : 7',
			moznosti: [
				{
					id: 1,
					moznost: '9',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '9',
		},
		{
			id: 16,
			priklad: '28 : 7',
			moznosti: [
				{
					id: 1,
					moznost: '3',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '4',
		},
		{
			id: 17,
			priklad: '14 : 7',
			moznosti: [
				{
					id: 1,
					moznost: '2',
				},
				{
					id: 2,
					moznost: '4',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '3',
				},
			],
			vysledek: '2',
		},
		{
			id: 18,
			priklad: '7 : 7',
			moznosti: [
				{
					id: 1,
					moznost: '3',
				},
				{
					id: 2,
					moznost: '4',
				},
				{
					id: 3,
					moznost: '1',
				},
				{
					id: 4,
					moznost: '2',
				},
			],
			vysledek: '1',
		},
		{
			id: 19,
			priklad: '21 : 7',
			moznosti: [
				{
					id: 1,
					moznost: '4',
				},
				{
					id: 2,
					moznost: '3',
				},
				{
					id: 3,
					moznost: '2',
				},
				{
					id: 4,
					moznost: '5',
				},
			],
			vysledek: '3',
		},
		{
			id: 20,
			priklad: '56 : 7',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '8',
				},
				{
					id: 4,
					moznost: '7',
				},
			],
			vysledek: '8',
		},
		{
			id: 21,
			priklad: '6 x 7',
			moznosti: [
				{
					id: 1,
					moznost: '54',
				},
				{
					id: 2,
					moznost: '36',
				},
				{
					id: 3,
					moznost: '42',
				},
				{
					id: 4,
					moznost: '48',
				},
			],
			vysledek: '42',
		},
		{
			id: 22,
			priklad: '7 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '70',
				},
				{
					id: 2,
					moznost: '63',
				},
				{
					id: 3,
					moznost: '56',
				},
				{
					id: 4,
					moznost: '49',
				},
			],
			vysledek: '63',
		},
		{
			id: 23,
			priklad: '8 x 7',
			moznosti: [
				{
					id: 1,
					moznost: '49',
				},
				{
					id: 2,
					moznost: '63',
				},
				{
					id: 3,
					moznost: '56',
				},
				{
					id: 4,
					moznost: '49',
				},
			],
			vysledek: '56',
		},
		{
			id: 24,
			priklad: '7 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '42',
				},
				{
					id: 2,
					moznost: '35',
				},
				{
					id: 3,
					moznost: '28',
				},
				{
					id: 4,
					moznost: '21',
				},
			],
			vysledek: '28',
		},
		{
			id: 25,
			priklad: '2 x 7',
			moznosti: [
				{
					id: 1,
					moznost: '14',
				},
				{
					id: 2,
					moznost: '35',
				},
				{
					id: 3,
					moznost: '28',
				},
				{
					id: 4,
					moznost: '21',
				},
			],
			vysledek: '14',
		},
	];
};

export default nasobilkaSedmi;
